import { ID, Layout } from "../types";
import Section from "./Section";

interface SectionListProps {
  sections: ID[];
  layout: Layout;
}

const SectionList: React.FC<SectionListProps> = ({ sections, layout }) => {
  return (
    <div className="section-list">
      {sections.map((id) => (
        <Section key={id} sectionId={id} layout={layout} />
      ))}
    </div>
  );
};

export default SectionList;
